import { createFileRoute } from "@tanstack/react-router";
import AnthemGeneralInsurance, { config } from "@/pages/AnthemGeneralInsurance";
import { buildInsuranceSchema } from "@/components/InsurancePageTemplate";
export const Route = createFileRoute("/anthem-general-insurance")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Anthem TMS & SPRAVATO Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Anthem insurance coverage for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Anthem TMS & SPRAVATO Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Anthem insurance coverage for TMS, SAINT TMS, and SPRAVATO. Prior auth and benefits verification for depression treatment in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/anthem-general-insurance",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/anthem-general-insurance",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(buildInsuranceSchema(config)),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <AnthemGeneralInsurance />;
}
